// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const defaultClientFetch = (
  url: RequestInfo | URL,
  init?: RequestInit,
) => {
  const csrfToken = document.documentElement.getAttribute('data-csrf');

  const augmentedHeaders: Record<string, unknown> = {
    ...((init && init.headers) || {}),
    'X-Requested-With': 'fetch',
  };

  if (csrfToken) {
    augmentedHeaders['x-stripe-csrf-token'] = csrfToken;
  }

  const augmentedInit = {
    credentials: 'same-origin',
    ...(init || {}),
    headers: augmentedHeaders as HeadersInit,
  } as const;

  return fetch(url, augmentedInit);
};
